'use strict'

domConfig = require './dom_config'
{omitUndefined} = require '../../helpers/underscore_replacement'

module.exports =
  PARAMS_BLACKLIST: [ "page" , "post_filters"]
  AVAILABLE_FACET_NAMES: ["hotelAvailability", "category2", "category3", "brand", "location", "price", "datetime", "age", "groups", "seasons", "indoor_outdoor", "badge", 'groupon_plus', 'shipping_pickup', 'distance', 'rating', 'delivery_pickup']

  updateParams: (selectedRefinements, isRefinementUpdated) ->
    enabledFacets = _getEnabledFacets(selectedRefinements)
    queryParams = _getFacetsFromUrl(selectedRefinements, @PARAMS_BLACKLIST, @AVAILABLE_FACET_NAMES)

    builtParams =
      category: _buildRefinementParam _getCategory(enabledFacets.category)
      category2: _buildRefinementParam _getCategory2(enabledFacets)
      category3: _buildRefinementParam enabledFacets.category3
      brand: _buildRefinementParam enabledFacets.brand
      location: _buildRefinementParam enabledFacets.location
      price: _buildRefinementParam enabledFacets.price
      age: _buildRefinementParam enabledFacets.age
      groups: _buildRefinementParam enabledFacets.groups
      badge: _buildRefinementParam enabledFacets.badge
      seasons: _buildRefinementParam enabledFacets.seasons
      indoor_outdoor: _buildRefinementParam enabledFacets.indoor_outdoor
      groupon_plus: _buildRefinementParam enabledFacets.groupon_plus
      shipping_pickup: _buildRefinementParam enabledFacets.shipping_pickup
      distance: _buildRefinementParam enabledFacets.distance
      rating: _buildRefinementParam enabledFacets.rating
      delivery_pickup: _buildRefinementParam enabledFacets.delivery_pickup

    updatedParams = _.defaults builtParams, queryParams

    if selectedValues = enabledFacets.sort?.selectedValues
      # This case happens when the `Sort By` is a Featured filter in the local page
      updatedParams.sort = selectedValues[0]?.name
    else if enabledFacets.sort and typeof enabledFacets.sort is 'string'
      # This case is the behaviour of `Sort By` implemented using the `grpn-sorts`
      updatedParams.sort = enabledFacets.sort

    if queries = enabledFacets.search
      updatedParams.query = _buildRefinementParam queries

    if rangeFilter = enabledFacets.rangeFilter
      _.extend updatedParams, _buildRangeFilterParam(rangeFilter)

    if dateTimeFilter = enabledFacets.datetime
      _.extend updatedParams, _buildDateTimeFilterParam(dateTimeFilter)

    if calendarFilter = enabledFacets.hotelAvailability
      _.extend updatedParams, _buildCalendarFilterParam(calendarFilter)

    if domConfig.get()?.showFilters
      _buildFiltersParams updatedParams, selectedRefinements

    omitUndefined updatedParams

_buildDateTimeFilterParam = ({selectedValues}) ->
  date = ''
  time = ''
  _.each(selectedValues, (refinement) ->
    if refinement.name == 'date'
      date = refinement.selectedValues[0].name
    if refinement.name == 'time'
      time = refinement.selectedValues[0].name
  )
  date = if date is "anyday" then '' else date
  time = if time is "anytime" then '' else time

  return unless date or time
  {datetime: "#{date}:#{time}"}

_buildCalendarFilterParam = (selectedValues) ->
  return unless selectedValues?.checkinDate? and selectedValues?.checkoutDate?

  hotelAvailability: "[#{selectedValues.checkinDate}..#{selectedValues.checkoutDate}]"

_getEnabledFacets = (selectedRefinements) ->
  category: _getNestedRefinements(selectedRefinements.category, "category")
  category2: _getNestedRefinements(selectedRefinements.category, "category2")
  category3: _getNestedRefinements(selectedRefinements.category, "category3")
  location: _getSelectedRefinements(selectedRefinements.location)
  search: _getSearchRefinement(selectedRefinements.search)
  rangeFilter: selectedRefinements.rangeFilters
  price: _getSelectedRefinements(selectedRefinements.price)
  brand: _getSelectedRefinements(selectedRefinements.brand)
  sort: selectedRefinements.sort
  datetime: selectedRefinements.datetime
  age: _getNestedRefinements(selectedRefinements.age, "age")
  groups: _getSelectedRefinements(selectedRefinements.groups)
  badge: _getSelectedRefinements(selectedRefinements.badge)
  seasons: _getSelectedRefinements(selectedRefinements.seasons)
  indoor_outdoor: _getSelectedRefinements(selectedRefinements.indoor_outdoor)
  groupon_plus: _getSelectedRefinements(selectedRefinements.groupon_plus)
  hotelAvailability: selectedRefinements.calendar?.selectedValues
  shipping_pickup: _getSelectedRefinements(selectedRefinements.shipping_pickup)
  distance: _getSelectedRefinements(selectedRefinements.distance)
  rating: _getSelectedRefinements(selectedRefinements.rating)
  delivery_pickup: _getSelectedRefinements(selectedRefinements.delivery_pickup)

_getFacetsFromUrl = (selectedRefinements, paramsBlacklist, availableFacetNames) ->
  availableFacetNames.push('query') if selectedRefinements.hasOwnProperty('search')
  _.omit Groupon.Utils.unparam(), availableFacetNames, paramsBlacklist

_getSelectedRefinements = (selectedRefinement) ->
  return unless selectedRefinement?.selectedValues.length

  _.pluck selectedRefinement.selectedValues, 'name'

_getSearchRefinement = (selectedRefinement) ->
  return unless selectedRefinement?.selectedValues.length
  _.pluck selectedRefinement.selectedValues, 'friendlyName'

_getNestedRefinements = (selectedRefinement, key, refinementNames = []) ->
  return [] unless selectedRefinement?.selectedValues?.length
  selectedRefinements = selectedRefinement.selectedValues

  _.each selectedRefinements, (refinement) ->
    if refinement.id is key
      refinementNames.push refinement.name
    else
      _getNestedRefinements(refinement, key, refinementNames)

  refinementNames

_buildRefinementParam = (param) ->
  return unless param?.length > 0
  param.join(',')

_buildFiltersParams = (updatedParams, selectedRefinements) ->
  for key, value of selectedRefinements
    if domConfig.get().filters?[key]?
      selectedFilterRefinement = _getSelectedRefinements value
      updatedParams[key] = _buildRefinementParam selectedFilterRefinement

_buildRangeFilterParam = (selectedRefinement) ->
  param = selectedRefinement.selectedValues?[0]

  minPrice: param?.selectedMin
  maxPrice: param?.selectedMax

_getCategory = (category) ->
  return if category[0] is "local"
  category

_getCategory2 = (enabledFacets) ->
  return [] if enabledFacets["category3"].length

  enabledFacets["category2"]
